import { supabase } from '../../lib/supabaseClient';

export type SocialLink = {
  id: string;
  platform: string;
  url: string;
  sort_order: number;
  created_at?: string;
};

export async function getSocialLinks() {
  const { data, error } = await supabase
    .from('social_links')
    .select('*')
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return (data ?? []) as SocialLink[];
}

export async function createSocialLink(payload: { platform: string; url: string; sort_order?: number }) {
  const { data, error } = await supabase
    .from('social_links')
    .insert({ ...payload, sort_order: payload.sort_order ?? 0 })
    .select('id')
    .single();
  if (error) throw error;
  return data.id as string;
}

export async function updateSocialLink(id: string, payload: Partial<SocialLink>) {
  const { error } = await supabase.from('social_links').update(payload).eq('id', id);
  if (error) throw error;
}

export async function deleteSocialLink(id: string) {
  const { error } = await supabase.from('social_links').delete().eq('id', id);
  if (error) throw error;
}
